const EquMaintainWarrantyStatus = type => {
	switch (type) {
		case 'warranty_period':
			return '安装质保期'
		case 'full':
			return  "全保"
		case 'man_made':
			return "技术保"
		case 'full_and_man_made':
			return "全保&技术保"
		case 'none':
			return "无保"
		case 'plant_full':
			return "原厂全保"
		case 'original_artificial':
			return "原厂人工保"
		case 'self_insurance':
			return  "自保"
		case 'three_insured':
			return  "三方在保"
	}
}
// 强检
const MeasureType = type =>{
	switch (type) {
		case 'non_imperative':
			return '非强检'
		case 'imperative':
			return  "强检"
	}
}
const EquStatus = type => {
	switch (type) {
		case 'editing':
			return '盘查中'
		case 'used':
			return  "启用"
		case 'unused':
			return "闲置"
		case 'discarding':
			return "待报废"
		case 'discarded':
			return "已报废"
		case 'discarded':
			return "验收中"
		case 'borrow':
			return "借用中"
		case 'probation':
			return  "试用中"
		case 'lease':
			return  "租借中"
		case 'lose':
			return "遗失"
		case 'under_repair':
			return "维修"
		case 'progress_maintain':
			return "保养"
		case 'measure':
			return  "计量"
		case 'store':
			return  "已入库"
		case 'under_review':
			return  "审核中"
		case 'audit_complete':
			return  "审核通过"
	}
}
const dateMonth = month =>{
	switch (month) {
		case '1月':
			return '01'
		case '2月':
			return '02'
		case '3月':
			return  '03'
		case '4月':
			return  '04'
		case '5月':
			return  '05'
		case '6月':
			return  '06'
		  case '7月':
			return  '07'
		  case '8月':
			return  '08'
		  case '9月':
			return  '09'
		  case '10月':
			return  '10'
		  case '11月':
			return  '11'
		  case '12月':
			return  '12'
	
	  }
}
// 品类
const category = type =>{
	switch (type) {
		case 'CT':
		  codeNumber = '06-02-01%'
		  break;
		case 'MR':
		  codeNumber = '06-09%'
		  break;
		case 'DR':
		  codeNumber = '06-01%'
		  break;
		case 'CR':
		  codeNumber = '06-04-03%'
		  break;
		case 'DSA':
		  codeNumber = '06-01-01%'
		  break;
		case 'MRI':
		  codeNumber = '06-17-03%'
		  break;
	  }
}

export default {
	EquMaintainWarrantyStatus,
	MeasureType,
	EquStatus,
	dateMonth,
	category
}


// WEBPACK FOOTER //
// ./src/utils/all-status.js